import { z } from 'zod';
import { claimFlexWorkerSchema } from '../platform-worker/platform-worker-service.schema';
import { workerEmploymentTypeSchema } from '../zod-schemas/schema';

const partnerSchema = z.object({
  name: z.string(),
});

const partnerWorkerSchema = z.object({
  workerId: z.string(),
  email: z.string(),
  firstName: z.string(),
  infix: z.string().nullable(),
  lastName: z.string(),
  phone: z.string(),
  partnerId: z.string(),
  employmentType: workerEmploymentTypeSchema,
  hasRequiredCertificate: z.boolean(),
  partner: partnerSchema,
});

const noShowReasonSchema = z.object({
  id: z.string(),
  longDescription: z.string(),
  shortDescription: z.string(),
  enabledForSelection: z.boolean(),
  allowsConsequences: z.boolean(),
  affectsAttendanceRate: z.boolean(),
});

const claimDetailsCommonSchema = z.object({
  claimId: z.string(),
  hourlyRateCents: z.number(),
  ratingPercentage: z.number().optional(),
  attendanceRate: z.number().optional(),
  isReplacement: z.boolean(),
});

// we cannot do union here because of the way zod unions work with objects currently
const claimAcceptedSchema = z.union([
  claimDetailsCommonSchema.extend({
    partnerWorker: partnerWorkerSchema,
    flexWorker: z.literal(null),
    state: z.enum(['accepted', 'checkoutSettled', 'checkoutPending', 'counterOffer']),
  }),
  claimDetailsCommonSchema.extend({
    partnerWorker: z.literal(null),
    flexWorker: claimFlexWorkerSchema,
    state: z.enum(['accepted', 'checkoutSettled', 'checkoutPending', 'counterOffer']),
  }),
]);

const claimCanceledSchema = z.union([
  claimDetailsCommonSchema.extend({
    partnerWorker: partnerWorkerSchema,
    flexWorker: z.literal(null),
    state: z.enum(['canceled', 'cancelationOfferPending', 'cancelationOfferSettled']),
    cancelationActor: z.enum(['unknown', 'byFW', 'byOG', 'byHQ']),
  }),
  claimDetailsCommonSchema.extend({
    partnerWorker: z.literal(null),
    flexWorker: claimFlexWorkerSchema,
    state: z.enum(['canceled', 'cancelationOfferPending', 'cancelationOfferSettled']),
    cancelationActor: z.enum(['unknown', 'byFW', 'byOG', 'byHQ']),
  }),
]);

const claimAcceptedNoShowSchema = z.union([
  claimDetailsCommonSchema.extend({
    partnerWorker: partnerWorkerSchema,
    flexWorker: z.literal(null),
    state: z.literal('noShow'),
    noShowReason: noShowReasonSchema,
  }),
  claimDetailsCommonSchema.extend({
    partnerWorker: z.literal(null),
    flexWorker: claimFlexWorkerSchema,
    state: z.literal('noShow'),
    noShowReason: noShowReasonSchema,
  }),
]);

export const claimDetailsSchema = z.union([
  claimAcceptedSchema,
  claimCanceledSchema,
  claimAcceptedNoShowSchema,
]);
